import { EnvironmentUrls } from 'Roblox';
import { THomepagePersonalizationVariation } from '../types/experimentTypes';

const { apiGatewayUrl } = EnvironmentUrls;

const url = {
  getExperimentationValues: (
    projectId: number,
    layerName: string,
    values: string[]
  ): { url: string; withCredentials: boolean } => ({
    url: `${apiGatewayUrl}/product-experimentation-platform/v1/projects/${projectId}/layers/${layerName}/values?parameters=${values.join(
      ','
    )}`,
    withCredentials: true
  })
};

const layerNames = {
  homePage: 'PlayerApp.HomePage.UX'
};

const defaultValues = {
  homePage: {
    UseOmniRecommendation: THomepagePersonalizationVariation.Default
  }
};

export default {
  url,
  defaultValues,
  layerNames,
  THomepagePersonalizationVariation
};
